import { genericJourneyResolverMapping } from '@dxb-web-ui-framework/mocks/msw/types';
import { genericMapToHandlers } from '@dxb-web-ui-framework/mocks/msw/utils/genericMapToHandlers';
import { ecommbx } from '../../index';

const dashboardMap: genericJourneyResolverMapping[] = [
  {
    url: /\/api\/private\/transactions\/document\/\d+\/\d+/,
    response: () => ecommbx.transactionDocumentsData,
    method: 'get',
  },
  {
    url: /\/api\/private\/transactions\/document\/\d+\/data/,
    response: () => ecommbx.transactionSingleDocumentData,
    method: 'get',
  },
  { url: /\/api\/private\/accounts\/\d+\/deposits/, response: () => ecommbx.accountsListData, method: 'get' },
  { url: /\/api\/private\/accounts\/dashboard/, response: () => ecommbx.dashboardData, method: 'get' },
  {
    url: /\/api\/private\/transactions\/account\/\d+\/print\/PDF/,
    response: () => ecommbx.transactionsPrintPDFData,
    method: 'get',
  },
  {
    url: /\/api\/private\/transactions\/account\/\d+\/print\/XLSX/,
    response: () => ecommbx.transactionsPrintXLSXData,
    method: 'get',
  },
  { url: /\/api\/private\/transactions\/account\/\d+/, response: () => ecommbx.transactionsListData, method: 'get' },
  {
    url: /\/api\/private\/transactions\/parameters\/statuses/,
    response: () => ecommbx.transactionStatusesData,
    method: 'get',
  },
  {
    url: /\/api\/private\/transactions\/parameters\/types/,
    response: () => ecommbx.transactionTypesData,
    method: 'get',
  },
  { url: /\/api\/private\/users\/postLogin/, response: () => ecommbx.postLoginData, method: 'get' },
  { url: /\/api\/private\/users\/appTransactions/, response: () => ecommbx.appTransactionsData, method: 'get' },
  { url: /\/api\/private\/availableLanguages/, response: () => ecommbx.availableLanguagesData, method: 'get' },
  {
    url: /\/api\/private\/transactions\/fund-transfers\/consolidated-history\/print\/PDF/,
    response: () => ecommbx.transactionsPrintPDFData,
    method: 'get',
  },
  {
    url: /\/api\/private\/transactions\/fund-transfers\/consolidated-history\/print\/XLSX/,
    response: () => ecommbx.transactionsPrintXLSXData,
    method: 'get',
  },
  {
    url: /\/api\/private\/transactions\/fund-transfers\/consolidated-history/,
    response: () => ecommbx.consolidatedTransactionsData,
    method: 'get',
  },
  {
    url: /\/api\/private\/transfers\/parameters\/order-statuses/,
    response: () => ecommbx.orderStatuses,
    method: 'get',
  },
  { url: /\/api\/private\/persistLanguage/, response: () => ecommbx.persistSelectedLanguageData, method: 'post' },
  {
    url: /\/secure-web\/ecommbx\/secure-web\/available-languages.json/,
    response: () => ecommbx.availableLanguagesData,
    method: 'get',
  },
  {
    url: /\/public-web\/ecommbx\/public-web\/available-languages.json/,
    response: () => ecommbx.availableLanguagesData,
    method: 'get',
  },
  {
    url: /\/secure-web\/ecommbx\/secure-web\/dictionary-en-GB.json/,
    response: () => ecommbx.translationsSecureData,
    method: 'get',
  },
  {
    url: /\/public-web\/ecommbx\/public-web\/dictionary-en-GB.json/,
    response: () => ecommbx.translationsPublicData,
    method: 'get',
  },
  {
    url: /\/api\/private\/transactions\/fund-transfers\/single\/PDF/,
    response: () => ecommbx.transactionDetailsPrintData,
    method: 'get',
  },
  {
    url: /\/api\/private\/transactions\/fund-transfers\/single/,
    response: () => ecommbx.consolidatedTransactionDetailsData,
    method: 'get',
  },
  {
    url: /\/api\/private\/transactions\/document\/\d+/,
    response: () => ecommbx.transactionDocumentUploadData,
    method: 'post',
  },
  {
    url: /\/api\/private\/transactions\/document\/\d+/,
    response: () => ({}),
    method: 'delete',
  },
];

const dashboardHandlers = dashboardMap.map(genericMapToHandlers);

export { dashboardHandlers };
